import PrimerAssemblyTabState from 'assembly/tabs/primer-assembly/backbone/PrimerAssemblyTabState';

class GoldenGateTabState extends PrimerAssemblyTabState {}

export default GoldenGateTabState;
